import React, { useEffect } from 'react'
import { Helmet } from 'react-helmet';
import { connect } from 'react-redux';
import { useLocation } from 'react-router-dom';
const HelmetDetails = ({ siteTheme, metaURL, metaTitle, metaDescription, metaImage, pageTitle, headerSetting, languageDetailsData }) => {
    const location = useLocation();
    const segments = location.pathname?.split('/');
    const lastSegment = segments.filter(segment => segment !== '').pop();


    const navigateTranslateChecker = (path) => {
        if (siteTheme?.translate_checkout) {
            return `/${languageDetailsData?.Language_Code}${path}`
        }
        else {
            return `${path}`
        }
    }

    return (
        <Helmet>
            <title>{metaTitle ? metaTitle : (headerSetting?.website_name || 'Advertiser Portal')}</title>
            <meta name="description" content={metaDescription || headerSetting?.website_description} />
            <meta property="og:description" content={metaDescription || headerSetting?.website_description} />
            <meta property="og:url" content={metaURL || window.location.href} />
            <meta property="og:title" content={metaTitle || headerSetting?.website_name} />
            <meta property="og:image" content={metaImage || headerSetting?.logo_url} />
            <link rel="canonical" href={process.env.REACT_APP_Baseurl_Frontend} />
            <link rel="icon" type="image/x-icon" href={headerSetting?.favicon_url} sizes={`${headerSetting?.logo_height}x${headerSetting?.logo_width}`} />
        </Helmet>
    )
}
const mapStateToProps = state => ({
    headerSetting: state.get_headerIndex_Reducer.headerSetting,
});
export default connect(mapStateToProps)(HelmetDetails)